import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { TableIndustryAnalysis } from '../../common/table'
import {
  changeActiveRow,
  selectActiveRowGroupId,
  selectCellData,
  selectData,
  selectHeaders,
  selectIds,
  selectRowGroup,
} from './store/slice'

export const LiquiditySolvencyCoverageTable = ({ isDynamicReport }) => {
  const activeRowGroupId = useSelector(selectActiveRowGroupId)
  const ids = useSelector(selectIds)
  const headers = useSelector(selectHeaders)

  return (
    <TableIndustryAnalysis
      isDynamicReport={isDynamicReport}
      dataTable={{
        activeRowGroupId,
        changeActiveRow,
        headers,
        ids,
        selectCellData,
        selectData,
        selectRowGroup,
      }}
    />
  )
}

LiquiditySolvencyCoverageTable.propTypes = {
  isDynamicReport: PropTypes.bool,
}
